<template>
  <div v-loading="showFlag">
    <!--  発送予定詳細製品選択画面 -->
    <t-card>
      <div :style="{ height: basicHeight + 'px' }" class="search">
        <t-form
          :model="searchConditionForm"
          label-position="right"
          :label-width="$t('widgetSize.COMMON_WIDTH.NINETY_PX')"
        >
          <t-row class="col_common_center">
            <t-col :span="1">&nbsp;</t-col>

            <t-col :span="8">
              <!-- 得意先納期 -->
              <div>
                <t-form-item
                  :label="$t('resource.ACCEPT_ORDER.CUSTOMER_DELIVERY_DATE')"
                >
                  <!-- 得意先納期(開始日～終了日) -->
                  <t-date-picker
                    v-model="dateCusRange"
                    type="daterange"
                    range-separator="～"
                    start-placeholder="開始日"
                    end-placeholder="終了日"
                    value-format="yyyy/MM/dd"
                    class="date_icon_center"
                    :clearable="false"
                    style="min-width: 20px; width: 75%"
                    format="yyyy/MM/dd"
                    :editable="false"
                  >
                  </t-date-picker>
                </t-form-item>
              </div>
            </t-col>
            <!-- UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓ -->
            <!-- <t-col :span="8" class="right"> -->
            <t-col :span="1">&nbsp;</t-col>

            <t-col :span="7" label-position="right" class="right">
              <!-- UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑ -->
              <!-- 仕入先納期 -->
              <div>
                <t-form-item
                  :label="$t('resource.ACCEPT_ORDER.SUPPLIER_DELIVERY_DATE')"
                >
                  <!-- 仕入先納期(開始日～終了日) -->
                  <t-date-picker
                    style="min-width: 20px; width: 100%"
                    v-model="dateSupRange"
                    type="daterange"
                    range-separator="～"
                    start-placeholder="開始日"
                    end-placeholder="終了日"
                    value-format="yyyy/MM/dd"
                    class="date_icon_center"
                    :clearable="true"
                    format="yyyy/MM/dd"
                    :editable="false"
                  >
                  </t-date-picker>
                </t-form-item>
              </div>
            </t-col>
            <t-col :span="1">&nbsp;</t-col>

            <!-- 輸送方式 -->
            <t-col :span="5">
              <t-form-item
                :label="$t('resource.TRANSPORT.TRANSPORT_METHOD')"
                class="marginBottom"
              >
                <t-select
                  placeholder=""
                  class="commonDialog"
                  v-model="searchConditionForm.searchTransMethod"
                >
                  <t-option
                    v-for="item in transMethodList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <t-col :span="1">&nbsp;</t-col>
          </t-row>

          <t-row>
            <t-col :span="1">&nbsp;</t-col>
            <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
            <!-- <t-col :span="16" class="right"> -->
            <t-col :span="13" class="right">
              <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
              <!-- 検索キー -->
              <t-form-item :label="$t('resource.sys.searchKey')">
                <t-input
                  v-model="searchConditionForm.searchWord"
                  class="input_searchKey"
                  maxLength="50"
                  clearable
                >
                </t-input>
              </t-form-item>
            </t-col>
            <t-col :span="1">&nbsp;</t-col>
            <!-- ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
            <!-- 一式機能の追加 -->
            <t-col :span="2" class="center">
              <template>
                <t-checkbox
                  v-model="aobASetOnly"
                  :label="$t('resource.SEND.A_SET_ONLY')"
                  style="line-height: 3.5"
                />
              </template>
            </t-col>
            <t-col :span="1">&nbsp;</t-col>
            <!-- ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
            <t-col :span="2" class="center">
              <template>
                <!-- 打合中有 -->
                <t-checkbox
                  v-model="discussingFlg"
                  :label="$t('resource.PREPARE_TRANS.FLG_DISCUSSING_EXIST')"
                  style="line-height: 3.5; margin-right: 40px"
                />
              </template>
            </t-col>
            <t-col :span="3" class="right">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                ref="searchBtn"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.sys.search") }}
              </t-button>
            </t-col>
            <t-col :span="1">&nbsp;</t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <t-table
                :data="prodSelectForm"
                ref="prodSelectForm"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                :row-class-name="rowClassName"
                highlight-current-row
                border
                fit
              >
                <!-- 選択ボックス -->
                <t-table-column type="selection" class-name="cell_txt_center">
                </t-table-column>
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                </t-table-column>
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 共通備考の調整 -->
                <!-- <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  class="cell_txt_center"
                  :min-width="100"
                >
                  <template slot-scope="scope">
                    <div class="button-container">
                      <t-tooltip placement="bottom" effect="light">
                        <div
                          slot="content"
                          class="tooltip-content"
                          v-html="
                            formatRemarksShowProc(scope.row.aodProdRemarksSum)
                          "
                        ></div>
                        <t-button
                          :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                          icon="el-icon-search"
                          size="small"
                          circle
                        >
                        </t-button>
                      </t-tooltip>
                    </div>
                  </template>
                </t-table-column> -->
                <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  prop="aodProdRemarksSum"
                  :class-name="'cell_txt_center'"
                  :width="getRemarksColumnWidthProc()"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div class="bikouDiv">
                      <!-- 備考表示 -->
                      <span class="bikouText">
                        {{ scope.row.aodProdRemarksSum }}
                      </span>
                    </div>
                  </template>
                </t-table-column>
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row type="flex" justify="end">
            <div>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
              <t-col
                :span="
                  parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_TWO'))
                "
              >
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  @click="ConfirmClick"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
import {
  cmpDetailData,
  formatCurDateToString,
  formatRemarksShow,
  getDialogContentHeight,
  getIconType,
  getNextMonthDate,
  getNextNumMonthDate,
  getRemarksColumnWidth,
  ShowMergeExKbn,
} from "@/utils/comFunction";

import { getInitList, searchProdSelectInfo } from "@/services/prepareTrans";
import {
  DIALOG_LINE_HEIGHT,
  NORMAL_PROD,
  NUM_TWO,
  STR_EMPTY,
} from "@/utils/const";
import { flexColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      // ========================検索条件=================
      // 得意先納期
      dateCusRange: [],
      // 仕入先納期
      dateSupRange: [],

      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
      // 課題_打合状態、納期の追加
      discussingFlg: false,
      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      aobASetOnly: false, //一式のみ
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      searchConditionForm: {
        searchCrbSupCode: "", // 仕入先
        searchTransMethod: "", // 輸送方式
        searchStartDate: "", // 日付(開始日)
        searchEndDate: "", // 日付(終了日)
        searchStartCusDate: "", // 得意先納期日付(開始日)
        searchEndCusDate: "", // 得意先納期日付(終了日)
        searchWord: "", // 検索キー
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
        // 課題_打合状態、納期の追加
        searchDiscussingFlg: "", //打合中有
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        aobASetOnly: "", //一式のみ
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
      },

      //運送一覧選択情報
      prodSelectForm: [],

      // ========================初期リスト=================
      //輸送方式リスト
      transMethodList: [],
      //製品異常区分リスト
      prodExKbnList: [],
      // 仕入先リスト
      supNameList: [],

      //仕入先見積依頼のテーブルの列
      columns: [
        {
          // 手配NO.
          prop: "ptdOrderNoShow",
          label: t("resource.PREPARE_TRANS.ORDER_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FORTY"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        {
          // 仕入先
          prop: "supName",
          label: t("resource.TRANSPORT.SUPPLIER_COMPANY"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
        // 緊急度の追加
        {
          prop: "aodUrgent",
          label: t("resource.ACCEPT_ORDER.AOD_URGENT"),
          width: t("widgetSize.tableCommon.width60"),
          align: "center",
        },
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
        {
          // 仕入先納期
          prop: "odDueDateShow",
          label: t("resource.PREPARE_TRANS.SUPPLIER_DUE_DATE"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },

        {
          // 得意先納期
          prop: "aodDeliveryDateShow",
          label: t("resource.PREPARE_TRANS.CUSTOMER_DELIVERY_DATE"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },

        // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
        // 未運送製品選択画面の一覧列「検査室入荷日」の追加
        {
          // 検査室入荷日
          prop: "crbReceDateShow",
          label: t("resource.PREPARE_TRANS.RECEIVE_DATE"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TEN"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.PREPARE_TRANS.PRODUCT_NAME"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.PREPARE_TRANS.PROD_DRAW_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 手配数
        {
          prop: "odProdQty",
          label: t("resource.PREPARE_TRANS.ORDER_QTY"),
          width: t("widgetSize.COMMON_WIDTH.SIXTY"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 打合状態
        {
          prop: "aodDiscussStatus",
          label: t("resource.checkReceInfo.PROD_DISCUSS_STATUS"),
          width: t("widgetSize.tableCommon.width80"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
        // 輸送方式の追加
        {
          prop: "tbTransMethod",
          label: t("resource.PREPARE_TRANS.TRANSPORT_METHOD"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
        // DEL 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
        // 検索結果の変更
        // // 重量
        // {
        //   prop: "aodUWeight",
        //   label: t("resource.PREPARE_TRANS.PROD_WEIGHT"),
        //   width: t("widgetSize.COMMON_WIDTH.SIXTY"),
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },
        // // 異常区分
        // {
        //   prop: "ptdProdExKbnShow",
        //   label: t("resource.PREPARE_TRANS.ABNORMAL_DIFFERENCE"),
        //   width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        //   overflowTooltip: false,
        // },
        // {
        //   // 検査室入荷数
        //   prop: "chkRevQty",
        //   label: t("resource.PREPARE_TRANS.CHECK_RECEIVE_QUANTITY"),
        //   width: t("widgetSize.COMMON_WIDTH.SEVENTY"),
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },

        // {
        //   // 運送完了数
        //   prop: "transOverQty",
        //   label: t("resource.PREPARE_TRANS.TRANSPORT_OVER_QTY"),
        //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },
        // {
        //   // 運送残
        //   prop: "transRemainQty",
        //   label: t("resource.PREPARE_TRANS.TRANS_REMAIN_QTY"),
        //   width: t("widgetSize.COMMON_WIDTH.SEVENTY"),
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },
        // DEL 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
      ],

      showFlag: false,

      // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 未運送製品選択画面と文字サイズの調整
      ////明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      // detailHeight: getDialogContentHeight(
      //   window.innerHeight,
      //   DIALOG_LINE_HEIGHT * 2,
      //   DIALOG_LINE_HEIGHT * 1,
      //   35
      // ),
      detailHeight: getDialogContentHeight(
        window.innerHeight * 0.9,
        DIALOG_LINE_HEIGHT * 2,
        DIALOG_LINE_HEIGHT * 1,
        15
      ),
      // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

      basicHeight: DIALOG_LINE_HEIGHT * 2,

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      // 読み込み回数
      numLoads: 1,

      // 比較用明細情報
      cmpDetailResult: "",
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    tableData: {
      Type: Object,
      default: null,
    },
    ptbNo: {
      Type: Object,
      default: null,
    },
    // 製品選択画面の検索条件
    selectedSearchForm: {
      Type: Object,
      default: null,
    },
  },
  mounted() {
    // 初期化
    this.init();
    // 列幅に自動調整
    // setColumnWidth(this.columns, this.prodSelectForm);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 未運送製品選択画面と文字サイズの調整
      // this.detailHeight = getDialogContentHeight(
      //   window.innerHeight,
      //   DIALOG_LINE_HEIGHT * 2,
      //   DIALOG_LINE_HEIGHT * 1,
      //   35
      // );
      this.detailHeight = getDialogContentHeight(
        window.innerHeight * 0.9,
        DIALOG_LINE_HEIGHT * 2,
        DIALOG_LINE_HEIGHT * 1,
        15
      );
      // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
    },

    // 初期化
    init() {
      this.showFlag = true;
      ///基本情報のリスト取得（仕入先、担当者）
      getInitList()
        .then((res) => {
          //仕入先リスト
          this.supNameList = res.supNameList;
          // 輸送方式
          this.transMethodList = res.transMethodList;
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // 輸送方式（空白のオプション）の追加
          this.transMethodList.unshift({
            label: "",
            value: "",
          });
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

          // 製品異常区分リスト
          this.prodExKbnList = res.prodExKbnList;

          //運送製品選択画面の検索条件が空しない場合
          if (
            !!this.selectedSearchForm &&
            this.selectedSearchForm != STR_EMPTY
          ) {
            this.searchConditionForm = [];
            this.searchConditionForm = this.selectedSearchForm;
            if (this.searchConditionForm.searchStartDate == STR_EMPTY) {
              this.dateSupRange = [];
            } else {
              this.dateSupRange = [
                this.searchConditionForm.searchStartDate,
                this.searchConditionForm.searchEndDate,
              ];
            }

            // 得意先納期日付の開始日が空の場合
            if (this.searchConditionForm.searchStartCusDate == STR_EMPTY) {
              this.dateCusRange = [];
            } else {
              this.dateCusRange = [
                this.searchConditionForm.searchStartCusDate,
                this.searchConditionForm.searchEndCusDate,
              ];
            }

            // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
            // 課題_打合状態の追加
            // 打合中有
            this.discussingFlg = this.searchConditionForm.searchDiscussingFlg;
            // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

            // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
            // 一式機能の追加
            this.aobASetOnly = this.searchConditionForm.aobASetOnly; //一式のみ
            // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          } else {
            //日付初期化
            this.dateInit();
            // UPD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 start↓
            // 輸送方式：デフォルトがエラー便を表示する
            // this.searchConditionForm.searchTransMethod =
            //   this.transMethodList[0]?.value;
            this.searchConditionForm.searchTransMethod =
              this.transMethodList[1]?.value;
            // UPD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 end↑
          }

          this.searchClick();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
          this.showFlag = false;
        });
    },

    //日付初期化
    dateInit() {
      //システム日付
      var systemDate = new Date();
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      //日付初期値の設定
      // this.dateCusRange = [systemDate, getNextMonthDate(systemDate)];
      // 得意先納期が「システム日付 ～システム日付+2ヶ月」の変更
      this.dateCusRange = [
        systemDate,
        getNextNumMonthDate(systemDate, NUM_TWO),
      ];
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      //日付初期値の設定
      this.dateSupRange = [systemDate, getNextMonthDate(systemDate)];
    },

    // 検索
    searchClick() {
      // フォーカス削除
      this.$refs.searchBtn.$el.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }

      // 検索条件の処理
      this.updateSearchForm();

      searchProdSelectInfo({
        prepTransSelectSearchInfo: this.searchConditionForm,
        ptdNo: this.ptbNo,
      })
        .then((res) => {
          this.prodSelectForm = res.prepTransDetailInfoList;

          this.checkedProcess();

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
          // データ処理
          // 列幅に自動調整
          // setColumnWidth(this.columns, this.prodSelectForm);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //チェックボックスの選択処理
    checkedProcess() {
      if (this.tableData.length > 0) {
        const tableKeys = new Set(
          this.tableData.map(
            (row) => `${row.ptdOrderNo}:${String(row.ptdDetailNo)}`
          )
        );
        // 選択したデータを表示しない
        this.prodSelectForm = this.prodSelectForm.filter(
          (item) =>
            !tableKeys.has(`${item.ptdOrderNo}:${String(item.ptdDetailNo)}`)
        );
      }

      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      this.prodSelectForm.map((item) => {
        item.ptdProdExKbnShow = ShowMergeExKbn(
          item.ptdProdExKbn,
          item.ptdProdReceExKbn
        );
      });

      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

      // 読み込み回数 = 1
      if (this.numLoads == 1) {
        let data = this.$refs.prodSelectForm.selection;

        // 比較用明細情報
        this.cmpDetailResult = JSON.parse(JSON.stringify(data));

        // 読み込み回数 + 1
        this.numLoads = this.numLoads + 1;
      }
    },

    //検索条件の調整
    updateSearchForm() {
      //スペースを削除
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();

      // 得意先納期
      if (this.dateCusRange) {
        this.searchConditionForm.searchStartCusDate = formatCurDateToString(
          this.dateCusRange[0]
        );
        this.searchConditionForm.searchEndCusDate = formatCurDateToString(
          this.dateCusRange[1]
        );
      } else {
        // 得意先納期の日付が空の場合、
        this.searchConditionForm.searchStartCusDate = STR_EMPTY;
        this.searchConditionForm.searchEndCusDate = STR_EMPTY;
      }

      // 仕入先納期
      if (this.dateSupRange) {
        this.searchConditionForm.searchStartDate = formatCurDateToString(
          this.dateSupRange[0]
        );
        this.searchConditionForm.searchEndDate = formatCurDateToString(
          this.dateSupRange[1]
        );
      } else {
        //仕入先納期日付が空の場合、
        this.searchConditionForm.searchStartDate = STR_EMPTY;
        this.searchConditionForm.searchEndDate = STR_EMPTY;
      }

      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
      // 課題_打合状態、納期の追加
      // 打合中有
      this.searchConditionForm.searchDiscussingFlg = this.discussingFlg;
      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // 一式機能の追加
      this.searchConditionForm.aobASetOnly = this.aobASetOnly; //一式のみ
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
    },

    //列幅に自動調整
    FlexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.prodSelectForm);
    },

    //确定ボタン
    ConfirmClick() {
      this.tableData;
      // let data = this.$refs.prodSelectForm.selection;

      let sortData = this.$refs.prodSelectForm.selection.sort((a, b) => {
        // 仕入先名でソート
        if (a.supName < b.supName) return -1;
        if (a.supName > b.supName) return 1;

        // 手配No.でソート
        if (a.ptdOrderNo < b.ptdOrderNo) return -1;
        if (a.ptdOrderNo > b.ptdOrderNo) return 1;

        // 図番でソート
        if (a.aodProdDrawNo < b.aodProdDrawNo) return -1;
        if (a.aodProdDrawNo > b.aodProdDrawNo) return 1;

        // 手配明細No.でソート
        return a.ptdDetailNo - b.ptdDetailNo;
      });

      let data = this.tableData.concat(sortData);

      if (!!data && data.length > 0) {
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
        // 今回選択したデータ
        let filterData = data.filter((obj) => "tbTransMethod" in obj);
        //輸送方式値:  混在⇒空、エアー便⇒エアー便、船便⇒船便
        let transMethodSelected = filterData.every(
          (obj) => obj?.tbTransMethod === filterData[0]?.tbTransMethod
        )
          ? filterData[0]?.tbTransMethod
          : "";
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

        var result = [
          { key: "selectedProcForm", value: data },
          { key: "searchConditionForm", value: this.searchConditionForm },
          // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // 輸送方式の追加
          { key: "transMethodSelected", value: transMethodSelected },
          // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
        ];
        this.$emit("ok", result);
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    // 製品異常
    rowClassName({ row }) {
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // if (!!row.ptdProdExKbn && row.ptdProdExKbn != "") {
      //   if (row.ptdProdExKbn != STR_ZERO) {
      //     return "textColor";
      //   }
      // }
      if (row.ptdProdExKbnShow != NORMAL_PROD) {
        return "textColor";
      }
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
    },

    // ダイアログを閉じる
    onCancel() {
      if (
        !cmpDetailData(
          this.cmpDetailResult,
          this.$refs.prodSelectForm.selection
        ) &&
        this.cmpDetailResult.length > 0
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.prodSelectForm);
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
</style>
